import { Card, Stack, Text, Spinner } from '@chakra-ui/react';
import { GraphView } from '../../lib/state/ViewTypes';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Node } from '../../lib/api/APITypes';
import { useLazyGetNodeQuery } from '../../lib/api/GraphAPI';
import StyledButton from '@/components/ui/styledButton';

export default function GraphItem(props: { graph: GraphView }) {
  const navigate = useNavigate();

  const [centerNode, setCenterNode] = useState<Node | null>(null);
  const [nodeQuery] = useLazyGetNodeQuery();
  const [loading, setLoading] = useState(false);
  const [usedDatasets, setUsedDatasets] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (props.graph.centerNode) {
      setLoading(true);
      nodeQuery(props.graph.centerNode).then((res) => {
        if (res.data) {
          setCenterNode(res.data);
        }
        setLoading(false);
      });
    }

    if (props.graph.serializedGraph) {
      const datasets = new Set<string>();
      props.graph.serializedGraph.nodes.forEach((node) => {
        const dataset = node.attributes.id.split(':')[0];
        datasets.add(dataset);
      });
      setUsedDatasets(datasets);
    }
  }, [props.graph.centerNode]);

  return (
    <Card.Root backgroundColor="cardDefault" variant="subtle" width="390px" height="fit-content">
      <Card.Header>
        <Stack>
          <Text color="primaryText" fontSize={'lg'} fontWeight="bold" key={props.graph.id}>
            {props.graph.name}
          </Text>
        </Stack>
      </Card.Header>
      <Card.Body>
        <Stack direction="column" width="100%">
          <Text color="secondaryText" fontSize="sm">
            # of Nodes: {props.graph.serializedGraph?.nodes.length}
          </Text>
        </Stack>
        {usedDatasets.size == 1 && (
          <Text color="secondaryText" fontSize={'md'}>
            Dataset: {Array.from(usedDatasets)[0]}
          </Text>
        )}
        {usedDatasets.size > 1 && (
          <Text color="secondaryText" fontSize={'md'}>
            Datasets: {Array.from(usedDatasets).join(', ')}
          </Text>
        )}
        {centerNode &&
          (loading ? (
            <Spinner />
          ) : (
            <Text color="secondaryText" fontSize="md">
              Center Node: {centerNode.label.split('CASE OF').at(-1)}
            </Text>
          ))}
        {!centerNode && (
          <Text color="secondaryText" fontSize="md">
            No Center Node
          </Text>
        )}
      </Card.Body>
      <Card.Footer justifyContent="end">
        <StyledButton
          variant="solid"
          text="Open Graph"
          onClick={() => navigate(`/graphs/${props.graph.id}`)}
        />
      </Card.Footer>
    </Card.Root>
  );
}
